var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NcAppNavigationItem,{attrs:{"name":_vm.section.name,"active":_vm.section.active,"href":_setup.href},scopedSlots:_vm._u([(_vm.section.icon)?{key:"icon",fn:function(){return [_c('img',{class:_vm.$style.settingsNavigationItem__icon,attrs:{"src":_vm.section.icon,"alt":""}})]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }